import slug from 'slug'

export function slugifyString(s) {
  if (!s)
    return ''
  return slug(s, { lower: true, trim: true, strict: true })
}
